import type React from 'react';
import { MetaBallImage } from './components/MetaBallImage';
import clsx from 'clsx';

export interface IMetaBallContainerProps {
  children: React.ReactNode;
  topLeftImage?: string;
  topRightImage?: string;
  bottomLeftImage?: string;
  bottomRightImage?: string;
}

export const MetaBallContainer = ({
  children,
  topRightImage,
  bottomRightImage,
  bottomLeftImage,
  topLeftImage,
}: IMetaBallContainerProps) => (
  <section
    className={clsx('print:hidden relative min-w-full overflow-hidden meta-ball-container')}
    id="metaball-container"
  >
    <MetaBallImage src={topRightImage} type="topRight" />
    <MetaBallImage src={bottomRightImage} type="bottomRight" />
    <MetaBallImage src={bottomLeftImage} type="bottomLeft" />
    <MetaBallImage src={topLeftImage} type="topLeft" />
    {children}
  </section>
);
